import { memo, type MouseEvent, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { MAIN_CONTENT_ID } from "./constants/main-content";

// NOTE: NSAI-7890 — the first tab stop of every signed-in page, hidden until
// focused. It jumps keyboard users past the sidebar and header toolbar
// straight into the page. Focus is moved by hand instead of following the
// hash, so the router's URL is never touched.
const SkipToMainContentComponent = (): JSX.Element => {
  const { t } = useTranslation("common");

  const handleClick = useCallback(
    (event: MouseEvent<HTMLAnchorElement>): void => {
      event.preventDefault();
      document.getElementById(MAIN_CONTENT_ID)?.focus();
    },
    [],
  );

  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      onClick={handleClick}
      data-testid="skip-to-main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:start-4 focus:top-4 focus:z-[100] focus:rounded-md focus:bg-background focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-foreground focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring"
    >
      {t("skip_to_main_content")}
    </a>
  );
};

export const SkipToMainContent = memo(SkipToMainContentComponent);
